/*
 * Copyright (c) GM Global Technology Operations LLC. All rights reserved.
 * This information is confidential and proprietary to GM Global Technology
 * Operations LLC and may not be used, modified, copied or distributed.
 */

import {HttpClient, HttpErrorResponse, HttpParams} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {Observable, throwError} from 'rxjs';
import {catchError} from 'rxjs/operators';
import {ConfigService} from './config.service';

@Injectable({
  providedIn: 'root'
})
export class RegionService {

  constructor(private readonly configService: ConfigService,
              private readonly http: HttpClient) {
  }

  getAllRegions(): Observable<any> {
    return this.http.get<any>(`${this.configService.baseApiUrl}regions`)
      .pipe(catchError(myError => this.handleError(myError)));
  }

  /**
   * Gets the distinct regions associated with an industry scenario
   * @param gmid The users gmid
   * @param indScenId The scenario ID
   */
  getAllRegionsByIndustryScenario(gmid: string, indScenId: number): Observable<any> {
    const params = new HttpParams().set('gmid', gmid).set('ind-scen-id', indScenId);

    return this.http.get<any>(`${this.configService.baseApiUrl}regions`, {params})
    .pipe(catchError(myError => this.handleError(myError)));
  }

  /**
   * Gets the distinct regions associated with an propulsion scenario
   * @param gmid The users gmid
   * @param propScenId The scenario ID
   */
  getAllRegionsByPropulsionScenario(gmid: string, propScenId: number): Observable<any> {
    const params = new HttpParams().set('gmid', gmid).set('prop-scen-id', propScenId);

    return this.http.get<any>(`${this.configService.baseApiUrl}regions`, {params})
    .pipe(catchError(myError => this.handleError(myError)));
  }


  /**
   * Gets the distinct regions associated with an vehicle scenario
   * @param gmid The users gmid
   * @param vehScenId The scenario ID
   */
  getAllRegionsByVehicleScenario(gmid: string, vehScenId: number): Observable<any> {
    const params = new HttpParams().set('gmid', gmid).set('veh-scen-id', vehScenId);

    return this.http.get<any>(`${this.configService.baseApiUrl}regions`, {params})
    .pipe(catchError(myError => this.handleError(myError)));
  }

  /**
   * Handles the errors produced by the backend
   * @param errorResponse The error produced by the API to be handled by the frontend
   */
  private handleError(errorResponse: HttpErrorResponse): Observable<any> {
    let errorMessage = 'An unexpected error has occurred.';
    if (errorResponse.error && errorResponse.error.message) {
      errorMessage = errorResponse.error.message;
    }
    return throwError(errorMessage);
  }
}
